/** @jsxImportSource @emotion/react */
import PatientShippingInformationVerification from 'components/landing/shippingVerification/PatientShippingInformationVerification'
import Success from "components/landing/shippingVerification/Success";
import { useEffect } from 'react'
import { Routes, Route, useParams, useNavigate } from 'react-router-dom'
import DobVerify from '../hstPaperwork/Verify'

import { useLazyGetPatientOrderQuery } from 'store/services/patientEndpoints'

const PoxShippingVerification = () => {
  const navigate = useNavigate()
  const { orderId } = useParams()
  const [getOrder, { currentData: order }] = useLazyGetPatientOrderQuery()

  useEffect(() => {
    if (orderId && localStorage.getItem('access_token')) {
      getOrder(Number(orderId))
    }
  }, [orderId, getOrder])

  return (
    <div className="">
      <Routes>
        <Route path={`success`} element={<Success />} />
        <Route
          path={`verification`}
          element={
            <PatientShippingInformationVerification order={order} nextStep={() => navigate(`success`)} />
          }
        />
        <Route
          path={``}
          element={
            <DobVerify
              poxShippingVerification={true}
              nextStep={() => navigate(`verification`)}
              title={'Pulse-Oximetry (POX) - Shipping information verification'}
              getOrder={getOrder}
            />
          }
        />
      </Routes>
    </div>
  )
}

export default PoxShippingVerification
